import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';


const accountRolesRoutes = [
  {
    path: 'roles',
    component: NestedRouteComponent,
    meta: {
      permissions: ['READ_USERACCOUNTS'],
      routeName: {
        segmentName: () => translation.tr('Roles')
      }
    },
    children: [
      {
        path: '',
        name: 'accountRoles',
        component: wrapLegacyRoute('useraccountsController', 'list')
      },
      {
        path: ':useraccountId(\\d+)',
        name: 'userAccountDetails',
        component: wrapLegacyRoute('useraccountsController', 'roleDetails')
      },
      {
        path: 'add',
        name: 'userAccountAdd',
        component: wrapLegacyRoute('useraccountsController', 'roleAdd')
      }
    ]
  }
];

export default accountRolesRoutes;
